export default __webpack_public_path__ + "static/media/m-fsk-17.2b039a71.jpg";